/**
 * Port para cifrar/descifrar valores antes de persistirlos en storage.
 *
 * La implementación concreta actual usa Base64 (EncryptionService legacy).
 * Al migrar a Web Crypto API solo se reemplaza la implementación,
 * sin tocar use-cases ni componentes del dominio.
 */
export abstract class StorageEncryptor {
  abstract encrypt(value: string): string;
  abstract decrypt(encrypted: string): string;
}
